import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getApiErrorMessage } from '@noor/api';
import { toast } from '@noor/lib';
import { moderationApi, type ModerationEntityType } from '@/entities/moderation';
import { useInvalidateModeration } from './use-invalidate-moderation';

export interface RejectChangeRequestArgs {
  changeRequestId: string;
  reason: string;
}

/**
 * Reject mutation for a moderation change request. Same invalidate-only
 * (and refresh-on-failure) contract as approve.
 */
export function useRejectChangeRequest(entityType: ModerationEntityType) {
  const { t } = useTranslation('moderation');
  const invalidate = useInvalidateModeration(entityType);
  return useMutation({
    mutationFn: ({ changeRequestId, reason }: RejectChangeRequestArgs) =>
      moderationApi.reject(changeRequestId, reason),
    onSuccess: () => {
      invalidate();
      toast.success(t('reject.success', 'Изменение отклонено'));
    },
    onError: (error) => {
      invalidate();
      toast.error(getApiErrorMessage(error, t('reject.error', 'Не удалось отклонить')));
    },
  });
}
